export const GROUP_BODY_CATEGORY_KEY = 'base' as const;
export const GROUP_BODY_PARENT_COMPONENT_KEY = 'tableGrouping' as const;
export const GROUP_BODY_COMPONENT_KEY = 'groupBody' as const;
